var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    {
      staticClass: "row h-100 bg-white",
      class: { toggle: _vm.toggle },
      attrs: { show: _vm.loadingFile }
    },
    [
      _c("rs-select-button", {
        attrs: {
          tooltip: _vm.getSelectionTooltip,
          disabled: _vm.selectButtonDisabled,
          "on-click": _vm.selectToDoc,
          "required-file-type": _vm.requiredFileType,
          "accepted-file-extensions": _vm.acceptedFileExtensions
        }
      }),
      _c("rs-file-table", {
        attrs: {
          "folder-elements": _vm.folderElements,
          "file-elements": _vm.fileElements,
          "loading-elements": _vm.loadingElements || _vm.loading,
          "is-empty-folder": _vm.isEmptyFolder
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }